import { createVuetify } from 'vuetify';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

const vuetify = createVuetify({
    components: {
        VAutocomplete,
    },
});

export default vuetify;
